import * as React from "react";
import classNames from "classnames";
import {
  Button,
  Menu,
  MenuItem,
  Checkbox,
  Tooltip,
  withStyles,
  Grid,
} from "@material-ui/core";
import i18n from "i18n";
import { Add, Delete } from "@material-ui/icons";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import MenuInputSearch from "common/components/fields/MenuInputSearch";
import ExclusionDialog from "./ExclusionDialog";
import { EModelMapType } from "common/enums";

const styles = (theme) => ({
  container: {
    padding: "0px 13px",
    height: 85,
  },
  inputContainer: { margin: "0px 2px" },
  selectedContainer: {
    paddingTop: 7,
    width: "100%",
  },
  inputCheck: { padding: "5px 0px", color: "#A8A8A8" },
  buttonDelete: {
    color: "#A8A8A8",
    margin: "0px 7px",
    fontSize: 19,
    marginBottom: 0,
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.primary.light,
    },
    transition: "all 0.3s ease-in",
  },
  button: {
    fontFamily: "Roboto",
    fontSize: "11px",
    color: "#A8A8A8",
    padding: "5px",
    marginRight: "5px",
    letterSpacing: "1px",
    fontWeight: "400" as any,
    border: "1px solid #1D1D1D",
    background: "#272727",
    "&:hover": {
      background: "#353539",
    },
    borderRadius: "4px",
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
});

interface IProps {
  classes: any;
  disabled?: boolean;
  checkedAll: boolean;
  showDeleteButton: boolean;
  showUpdateButton: boolean;
  onChangeSearch: (value: string) => void;
  onChangeCheckAll: (checked: boolean) => void;
  onConfirmDeleteSelected: () => void;
  onClickUpdateSelected: () => void;
  onClickCreate: (type: string) => void;
}

const MenuHeader = ({
  classes,
  disabled = false,
  checkedAll,
  showDeleteButton,
  showUpdateButton,
  onChangeSearch = () => {},
  onChangeCheckAll = () => {},
  onConfirmDeleteSelected = () => {},
  onClickUpdateSelected = () => {},
  onClickCreate = () => {},
}: IProps) => {
  const [checked, setChecked] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState();
  const [openDelete, setOpenDelete] = React.useState(false);
  const labels = i18n.modelMaps.menuLateral;
  const labelsLayer = i18n.modelMaps.addLayer;

  React.useEffect(() => {
    if (checked !== checkedAll) {
      setChecked(checkedAll);
    }
  }, [checkedAll]);

  const handleChangeCheck = (ev) => {
    const { checked } = ev.target;
    setChecked(checked);
    onChangeCheckAll(checked);
  };

  const handleClickCreate = (type) => () => {
    setAnchorEl(undefined);
    onClickCreate(type);
  };

  const handleOpenMenu = (ev) => {
    setAnchorEl(ev.currentTarget);
  };

  const handleOpenDelete = () => {
    setOpenDelete(true);
  };

  return (
    <div className={classes.container}>
      <Grid className={classes.inputContainer}>
        <MenuInputSearch
          disabled={disabled}
          handleChange={onChangeSearch}
          handleClean={() => onChangeSearch("")}
        />
      </Grid>
      <Grid
        container
        className={classes.selectedContainer}
        justify="space-between"
        alignItems="center"
      >
        <Grid item>
          <Grid container alignItems="center">
            <Checkbox
              className={classes.inputCheck}
              checked={checkedAll}
              onChange={handleChangeCheck}
            />
            {showDeleteButton && (
              <Tooltip title={i18n.delete}>
                <Delete
                  onClick={handleOpenDelete}
                  className={classes.buttonDelete}
                />
              </Tooltip>
            )}

            {showUpdateButton && (
              <Tooltip title={i18n.update}>
                <AutorenewIcon
                  className={classes.buttonDelete}
                  onClick={onClickUpdateSelected}
                />
              </Tooltip>
            )}
          </Grid>
        </Grid>
        <Grid item>
          <Button
            variant="outlined"
            size="small"
            className={classes.button}
            style={{ color: "rgba(255, 255, 255, 0.6)" }}
            aria-owns={anchorEl ? "simple-menu" : undefined}
            aria-haspopup="true"
            onClick={handleOpenMenu}
          >
            <Add className={classNames(classes.leftIcon, classes.iconSmall)} />
            {labels.newModel}
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(undefined)}
          >
            <MenuItem
              selected={false}
              onClick={handleClickCreate(EModelMapType.ELEMENT_CONSTRUCTIVE)}
            >
              {labelsLayer.constructiveElements}
            </MenuItem>
            <MenuItem
              selected={false}
              onClick={handleClickCreate(EModelMapType.MATERIAL)}
            >
              {labelsLayer.Materials}
            </MenuItem>
          </Menu>
        </Grid>
      </Grid>
      <ExclusionDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={() => onConfirmDeleteSelected()}
      />
    </div>
  );
};

export default withStyles(styles)(MenuHeader);



// WEBPACK FOOTER //
// ./src/modules/modelMap/components/layouts/MenuHeader.tsx